import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/CompanyIntr',
    name: 'CompanyIntr',
    component: () => import(/* webpackChunkName: "about" */ '../views/CompanyIntr.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import(/* webpackChunkName: "about" */ '../views/News.vue')
  },
  {
    path: '/new/:id',
    name: 'new',
    component: () => import(/* webpackChunkName: "about" */ '../views/New.vue')
  },
  {
    path: '/business',
    name: 'business',
    component: () => import(/* webpackChunkName: "about" */ '../views/Business.vue')
  },
  {
    path: '/connect',
    name: 'connect',
    component: () => import(/* webpackChunkName: "about" */ '../views/Connect.vue')
  },
  {
    path: '/fwdw',
    name: 'fwdw',
    component: () => import(/* webpackChunkName: "about" */ '../views/fwdw.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
